// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import VideoPlayer from 'vue-video-player'
import router from './router'
import store from './store'
import api from './api'
import BaseList from './components'
import {Carousel, CarouselItem, Pagination, Tabs, TabPane, Select, Option, Radio, RadioGroup, DatePicker} from 'element-ui';
import VueLazyLoad from 'vue-lazyload'
import Video from 'video.js'
import 'video.js/dist/video-js.css'


Vue.config.productionTip = false;

const {BaseNotFound, BasePlayer, BaseArea} = BaseList;

Vue.use(BaseNotFound).use(BasePlayer).use(BaseArea);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Pagination);
// Vue.use(VideoPlayer);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Select);
Vue.use(Option);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(DatePicker);

Vue.prototype.api = api;
Vue.prototype.$video = Video;

Video.addLanguage('zh-CN', {
    Play: '播放',
    Pause: '暂停',
    Fullscreen: '全屏',
    Mute: '静音',
    Unmute: '取消静音',
    'Non-Fullscreen': '退出全屏'
});

Vue.prototype.$time = e => {
    const now = ((new Date).getTime() - (new Date(e)).getTime()) / 1000;

    // if (now > 31536000) return `${~~(now / 31536000)}年前`;
    // if (now >= 2592000 && now < 31536000) return `${~~(now / 2592000)}个月前`;
    // if (now >= 604800 && now < 2592000) return `${~~(now / 604800)}个星期前`;
    // if (now >= 86400 && now < 604800) return `${~~(now / 86400)}天前`;

    if (now >= 3600 && now < 86400) return `${~~(now / 3600)}小时前`;
    if (now >= 60 && now < 3600) return `${~~(now / 60)}分钟前`;
    if (now < 60) return '刚刚';
    return e.substr(0, 16);
};

Vue.prototype.$date = e => {
    const now = ((new Date).getTime() - (new Date(e)).getTime()) / 1000;

    if (now >= 3600 && now < 86400) return `${~~(now / 3600)}小时前`;
    if (now >= 60 && now < 3600) return `${~~(now / 60)}分钟前`;
    if (now < 60) return '刚刚';
    return e.substr(0, 10);
};

Vue.prototype.$view = e => e > 9999 ? `${Math.round(e  / 1000) / 10}万` : e;

Vue.prototype.$duration = e => {
    const m = ~~(e / 1000 / 60), s = ~~(e / 1000 % 60);
    return `${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`;
};

Vue.prototype.alert =  {
    timer: 0,
    suc(e) {
        clearTimeout(this.timer);
        let {msg} = store.state;
        msg.suc_msg = e;
        msg.suc_show = true;
        setTimeout(() => msg.suc_show = false, 3000);
    },

    err(e) {
        clearTimeout(this.timer);
        let {msg} = store.state;
        msg.err_msg = e;
        msg.err_show = true;
        this.timer = setTimeout(() => msg.err_show = false, 3000);
    }
};

Vue.prototype.err = e => Vue.prototype.alert.err(e.message);

Vue.prototype.confirm = e => {
    let {confirm} = store.state;
    confirm.show = true;
    confirm.title = e.title || '温馨提示';
    confirm.sure = e.sure || '确认';
    confirm.cancel = e.cancel || '取消';
    confirm.content = e.content || '确定要继续操作吗?';
    confirm.sureCb = e.sureCb || null;
    confirm.cancelCb = e.cancelCb || null;
};

Vue.directive('waves', {
    bind: function(el, binding) {
        el.classList.add('waves-effect');
        let modifiers = Object.keys(binding.modifiers), l = modifiers.length, duration = +binding.expression || 200;
        while (l--) {
            el.classList.add(`waves-${modifiers[l]}`);
        }

        function convertStyle(obj) {
            let style = '';
            for (let a in obj) {
                if (obj.hasOwnProperty(a)) {
                    style += `${a}:${obj[a]};`
                }
            }
            return style;
        }

        el.addEventListener('mousedown', function(e) {
            let ripple = document.createElement('div');
            ripple.classList.add('waves-ripple');
            el.appendChild(ripple);

            let styles = {
                left: `${e.layerX}px`,
                top: `${e.layerY}px`,
                opacity: 1,
                transform: `scale(${(el.clientWidth / 100) * 10})`,
                'transition-duration': `${duration}ms`,
                'transition-timing-function': 'ease-in-out'
            };
            ripple.setAttribute('style', convertStyle(styles));
            setTimeout(function() {
                ripple.setAttribute('style', convertStyle({
                    opacity: 0,
                    transform: styles.transform,
                    left: styles.left,
                    top: styles.top,
                }));
                setTimeout(function() {
                    ripple && el.removeChild(ripple);
                }, duration * 3);
            }, duration);
        });
    },
});


router.beforeEach((to, from, next) => {
    //to即将进入的目标路由对象，from当前导航正要离开的路由， next : 下一步执行的函数钩子
    if (!store.state.user.id) {
        try {// 尝试获取storage里的user信息
            let user = JSON.parse(window.localStorage.getItem('user'));
            if (user.id) store.state.user = user;
        } catch (e) {// 获取不到不做处理

        }
    }

    if (!store.state.search.length) store.state.search = JSON.parse(window.localStorage.getItem('search')) || [];

    next();
});


Vue.use(VueLazyLoad, {
    error: 'https://img.vhiphop.com/web/loading-2.gif',
    loading: 'https://img.vhiphop.com/web/loading-2.gif'
});

// router.afterEach(() => window.scrollTo(0,0));

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js